import { useCurrentUserDetails } from 'entities/user/model';
import React, { useEffect, useState } from 'react';

import CompanyCreateForm from 'widgets/Organization/CompanyCreateForm';
import { Modal } from 'antd';

export const WithOrganization = ({ children }) => {
  const { hasLoggedInUser, hasAnyOrganization } = useCurrentUserDetails();
  const [showOrgModal, setShowOrgModal] = useState(false);

  useEffect(() => {
    if (hasLoggedInUser && !hasAnyOrganization) {
      setShowOrgModal(true);
    } else if (showOrgModal && hasAnyOrganization) {
      setShowOrgModal(false);
    }
  }, [hasLoggedInUser, hasAnyOrganization, showOrgModal]);

  const _handleClose = () => {
    if (hasAnyOrganization) {
      setShowOrgModal(false);
    }
  };

  return (
    <>
      {children}

      <Modal
        title={'Confirm Your Details'}
        open={showOrgModal}
        centered
        width={620}
        footer={null}
        destroyOnClose
        onCancel={_handleClose}>
        <CompanyCreateForm variant="confirm-details" />
      </Modal>
    </>
  );
};
